<template>
  <b-table :data="accesses" hoverable>
    <b-table-column
      field="createdAt"
      :label="$t('accesses.date')"
      sortable
      v-slot="props"
    >
      {{
        moment
          .utc(props.row.createdAt)
          .add(preferences.timezone, "h")
          .format("DD/MM/YY HH:mm:ss")
      }}
    </b-table-column>

    <b-table-column
      field="user.personalInfo.name"
      :label="$t('accesses.client')"
      sortable
      v-slot="props"
    >
      <div v-if="props.row.isTest">
        {{ $t("accesses.testMaintenance") }}
      </div>

      <column-merchant-access
        v-else-if="props.row.merchant"
        :name="props.row.merchant.ownerInfo.name"
      />

      <column-user v-else :user="props.row.user" />
    </b-table-column>

    <b-table-column
      field="device.store.storeInfo.name"
      :label="$t('accesses.store')"
      sortable
      v-slot="props"
    >
      {{ props.row.device.store.storeInfo.name }}
    </b-table-column>

    <b-table-column
      field="device.description"
      :label="$t('accesses.door')"
      sortable
      v-slot="props"
    >
      {{ props.row.device.description || "-" }}
    </b-table-column>

    <b-table-column
      field="readAt"
      :label="$t('accesses.answer')"
      sortable
      v-slot="props"
    >
      {{
        props.row.readAt
          ? moment
              .utc(props.row.readAt)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          : "-"
      }}
    </b-table-column>

    <b-table-column
      field="authorized"
      :label="$t('accesses.wasReleased')"
      v-slot="props"
      sortable
    >
      <authorized-column
        :authorized="props.row.authorized"
        :error="props.row.error"
        :accessType="props.row.accessType"
        :device="props.row.device"
      />
    </b-table-column>

    <b-table-column
      field="paid"
      :label="$t('accesses.payment')"
      v-slot="props"
      sortable
    >
      <paid-column :access="props.row" />
    </b-table-column>

    <b-table-column
      :custom-sort="statusSort"
      :label="$t('accesses.status')"
      v-if="permissions.seeAccessStatus"
      v-slot="props"
      sortable
    >
      <column-access-status :access="props.row" />
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import columnUser from "./ColumnUserInfo";
import columnMerchantAccess from "./ColumnMerchantAccess";
import columnAccessStatus from "./ColumnAccessStatus";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";
import authorizedColumn from "./AuthorizedColumn";
import paidColumn from "./PaidColumn";

export default {
  props: ["accesses"],

  components: {
    columnUser,
    columnMerchantAccess,
    columnAccessStatus,
    tableEmptyTemplate,
    authorizedColumn,
    paidColumn
  },

  methods: {
    statusSort(a, b, isAsc) {
      const sortWeight = o => {
        return o.status === "new"
          ? 1
          : o.status === "analyse"
          ? 2
          : o.status === "deviation"
          ? 3
          : o.status === "ok"
          ? 4
          : o.status === "recovered"
          ? 5
          : o.status === "loss"
          ? 6
          : 0;
      };
      a.v = sortWeight(a);
      b.v = sortWeight(b);
      return isAsc ? a.v - b.v : (a.v - b.v) * -1;
    }
  },

  computed: {
    ...mapGetters(["permissions", "preferences"])
  }
};
</script>

<style scoped>
.button {
  width: 150px;
}
.dropdown-status-column {
  text-align: left;
}
</style>
